import React from 'react';

import {
  layout,
  PermissionWall,
  widgets
} from 'modules';



export interface IProps {
  orderId: string;
  storeId: string;
  returnAuthorizationId: string;
  onDeleteReturnAuthorization: () => void;
}

export const FC: React.FC<IProps> = props => {
  return props.returnAuthorizationId ? (
    <layout.ColumnBox>
      <layout.RowBox>
        <layout.ColumnBox>
          <layout.RowBox>
            <widgets.returnAuthorization.ActionsWidget.FC
              storeId={props.storeId}
              returnAuthorizationId={props.returnAuthorizationId}
              onDeleteReturnAuthorization={props.onDeleteReturnAuthorization} />
          </layout.RowBox>

          <layout.RowBox>
            <PermissionWall.FC
              storeId={props.storeId}
              requiresPermissions={['inventory_viewProduct']}>
              <widgets.returnAuthorization.ReturnedProductsWidget.FC returnAuthorizationId={props.returnAuthorizationId} />
            </PermissionWall.FC>
          </layout.RowBox>

          <layout.RowBox>
            <widgets.returnAuthorization.SummaryWidget.FC returnAuthorizationId={props.returnAuthorizationId} />
            <widgets.order.PaymentInformationWidget.FC orderId={props.orderId} />
          </layout.RowBox>

          <layout.RowBox>
            <PermissionWall.FC
              storeId={props.storeId}
              requiresPermissions={['customer_viewCustomer']}>
              <widgets.order.CustomerInformationWidget.FC
                orderId={props.orderId}
                storeId={props.storeId} />
            </PermissionWall.FC>

            <widgets.returnAuthorization.ReturnShippingWidget.FC returnAuthorizationId={props.returnAuthorizationId} />
          </layout.RowBox>
        </layout.ColumnBox>

        <widgets.returnAuthorization.LifeCycleWidget.FC
          variant="partner"
          storeId={props.storeId}
          returnAuthorizationId={props.returnAuthorizationId} />
      </layout.RowBox>

      <layout.RowBox>
        <PermissionWall.FC requiresPermissions={['itemReceipt_view']}>
          <widgets.returnAuthorization.ItemReceiptWidget.FC returnAuthorizationId={props.returnAuthorizationId} />
        </PermissionWall.FC>
      </layout.RowBox>

      {/* messages */}
      <layout.RowBox>
        <widgets.common.PartnerChatWidget.FC
          storeId={props.storeId}
          returnAuthorizationId={props.returnAuthorizationId} />
      </layout.RowBox>

      {/* SendGrid Email Log */}
      <layout.RowBox>
        <PermissionWall.FC
          storeId={props.storeId}
          requiresPermissions={['customer_email']}>
          <widgets.common.SendGridEmailLogWidget.FC
            storeId={props.storeId}
            returnAuthorizationId={props.returnAuthorizationId} />
        </PermissionWall.FC>
      </layout.RowBox>

      {/* Audit log */}
      <layout.RowBox>
        <PermissionWall.FC
          storeId={props.storeId}
          requiresPermissions={['returnAuthorization_viewAuditLogEvents']}>
          <widgets.common.AuditLogWidget.FC
            storeId={props.storeId}
            returnAuthorizationId={props.returnAuthorizationId} />
        </PermissionWall.FC>
      </layout.RowBox>
    </layout.ColumnBox>
  ) : null;
};
